import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { useCommonStore } from '@/stores'
import { parseAxiosErrorResponseDataSync } from '@/utils/parseAxiosErrorResponseData'

export function getErrorCodeDescription(code) {
    const commonStore = useCommonStore()
    const errorCodes = commonStore?.errorCodes || []
    const match = errorCodes.find((item) => String(item.code) === String(code))

    return match ? match.description : null
}

export function handleApiError(error, defaultMessage = t('common.errors.unexpectedError')) {
    // 401 is handled globally in the response interceptor
    if (error?.response?.status === 401) return

    const data = parseAxiosErrorResponseDataSync(error?.response?.data)
    const status = error?.response?.status

    // Backend-specific error code resolution (array or scalar)
    if (data && data.errorCode !== undefined) {
        const codeValue = Array.isArray(data.errorCode) ? data.errorCode[0] : data.errorCode

        notificationService.error(getErrorCodeDescription(codeValue) || defaultMessage)
        return
    }

    // Forbidden with detail
    if (status === 403 && data) {
        notificationService.error(data.detail || defaultMessage)
        return
    }

    // Generic API error message fields
    if (data?.error) {
        notificationService.error(data.error)
        return
    }
    if (data?.message) {
        notificationService.error(data.message)
        return
    }

    // Network/timeout errors
    if (error?.code === 'ECONNABORTED' || error?.message === 'Network Error') {
        notificationService.error(t('common.errors.networkError'))
        return
    }

    // Fallback
    notificationService.error(defaultMessage)
}
